import Link from 'next/link'
import { Icon } from 'shared/iconpack'

import styles from './Section.module.scss'

interface SectionProps {
  title?: string
  link?: string
  linkLabel?: string
  children: React.ReactNode
}

// TODO поменять потом из палитры
export function Section({ link, linkLabel, title, children }: SectionProps) {
  return (
    <div className={styles.section}>
      {(!!title || !!link) && (
        <div className={styles.sectionHeader}>
          {title && <h4 className={styles.title}>{title}</h4>}
          {link && (
            <Link className={styles.link} href={link}>
              {linkLabel}
              <Icon name="chevronRight" size={14} color="#4c5c60" />
            </Link>
          )}
        </div>
      )}
      <div className={styles.sectionContent}>{children}</div>
    </div>
  )
}
